import React, { useCallback, useEffect, useRef, useState } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import LibraryApprovalEmblem from '../../admin/library/components/LibraryApprovalEmblem';
import LibraryBookApprovalList from '../../admin/library/components/LibraryBookApprovalList';
import '../../admin/library/LibraryPages.css';
import './teacherLibraryApprovals.css';

export function TeacherLibraryApprovalCard({ count, onOpen }) {
  if (!count) return null;
  return <Paper className="library-approval-card board-library-approval-card">
    <LibraryApprovalEmblem count={count} />
    <Box sx={{ minWidth: 0 }}>
      <Box className="library-approval-card__heading">
        <Typography component="h2">Kitap Onayları</Typography>
        <Chip className="library-pending-count" icon={<ScheduleRoundedIcon />} label={`${count} bekliyor`} />
      </Box>
      <Typography className="library-approval-card__description">Öğrencilerinizin tamamladığını bildirdiği kitaplar onayınızı bekliyor.</Typography>
    </Box>
    <Button className="library-primary library-approval-card__cta" variant="contained" endIcon={<ArrowForwardRoundedIcon />} onClick={onOpen}>Kitapları İncele</Button>
  </Paper>;
}

export default function TeacherLibraryApprovals({ request, classCode, onBack }) {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const mounted = useRef(true);
  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const payload = await request('library');
      if (mounted.current) setClaims(payload.pending_claims || []);
    } catch (err) {
      if (mounted.current) setError(err.message || 'Kitap onayları yüklenemedi.');
    } finally {
      if (mounted.current) setLoading(false);
    }
  }, [request]);
  useEffect(() => {
    mounted.current = true;
    refresh();
    return () => { mounted.current = false; };
  }, [refresh]);

  const review = async (id, action, corrections) => {
    const result = await request(`library/claims/${id}/${action}`, { method: 'POST', body: JSON.stringify(corrections || {}) });
    if (mounted.current) setClaims((current) => current.filter((claim) => claim.id !== id));
    return result;
  };

  return <Box className="library-page board-library-approvals">
    <Button startIcon={<ArrowBackRoundedIcon />} onClick={onBack}>Kütüphanem'e Dön</Button>
    <Box className="board-library-approvals__heading">
      <Typography component="h1">Kitap Onayları</Typography>
      <Chip label={`${classCode} Sınıfı`} />
    </Box>
    {loading ? <Box role="status" sx={{ py: 5, textAlign: 'center' }}><CircularProgress /><Typography>Kitap onayları yükleniyor…</Typography></Box>
      : error ? <Alert severity="error" action={<Button color="inherit" onClick={refresh}>Tekrar Dene</Button>}>{error}</Alert>
        : <>
          <Paper className="library-approval-summary" sx={{ mb: 2 }}>
            <LibraryApprovalEmblem count={claims.length} checked={claims.length === 0} />
            <Box><Typography component="h2" aria-live="polite">{claims.length} kitap onay bekliyor</Typography><Typography className="library-approval-summary__description">Öğrencilerinizin tamamladığını bildirdiği kitapları inceleyin.</Typography></Box>
          </Paper>
          <LibraryBookApprovalList claims={claims} onReview={review} smartboard onBack={onBack} />
        </>}
  </Box>;
}
